import { styled, createGlobalStyle } from "styled-components";
import { mobile, tablet } from "storybook/utils/breakpoints";

export const ModalBodyWrapper = styled.div`
  word-break: break-word;
  line-height: 26px;
`;

export const DeclineButtons = styled.div`
  gap: 10px;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: right;

  @media (min-width: ${mobile}px) {
    flex-direction: row;
    gap: 10px;
  }
`;

export const ConfirmButtons = styled.div`
  gap: 10px;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;

  @media (min-width: ${mobile}px) {
    flex-direction: row;
    gap: 10px;
  }
`;

export const BannerContainer = styled.div`
  margin-bottom: 20px;
`;

export const GlobalModalStyles = createGlobalStyle`
  [role="presentation"] {
    .MuiDialog-paper {
      overflow: visible; // Needed for date picker overlay
      padding: 2rem;
      // On certain devices, MUI styles are taking precendence, hence need for important.
      margin: 0 !important;
    }

    .close-btn {
      margin-right: 0;
    }
  }

  .MuiPaper-root {
    overflow: visible;
    min-height: fit-content;
    max-height: 100vh !important;
  }

  .MuiDialogTitle-root h2 {
    font-size: 28px !important;
    padding-right: 50px;
    margin-top: 10px;
  }

  @media (min-width: ${mobile}px) {
    .MuiDialogTitle-root h2 {
      margin-top: 10px;
    }
  }

    @media (min-width: ${tablet}px) {
    .MuiDialogTitle-root h2 {
      margin-top: -15px;
    }
  }

  .MuiDialogActions-root {
    button {
      text-transform: capitalize;
    }
  }
`;
